import { createHausifyApi } from "@/api/hausifyClient";
import { serializeError } from "@/functions/serializeError";
import { selectCurrentUser } from "@/modules/user/userActions";
import { createAppAsyncThunk } from "@/store/createAppAsyncThunk";
import type { Ticket } from "../ticketSharedTypes";
import { selectTicketListFilter } from "./ticketListSlice";

export const fetchTicketsByEstateIdThunk = createAppAsyncThunk(
  "tickets/fetchTicketsByEstateId",
  async (estateId: number, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const { filteredServiceTypeIds } = selectCurrentUser(state);
      const ticketListFilter = selectTicketListFilter(state);
      const filter: Record<string, any> = { estateId };

      if (filteredServiceTypeIds && filteredServiceTypeIds.length > 0) {
        filter.serviceTypeIds = filteredServiceTypeIds;
      }

      if (ticketListFilter && ticketListFilter.length > 0) {
        filter.processingStates = ticketListFilter;
      }

      const response = await createHausifyApi().findTickets(
        `["updatedAt","DESC"]`,
        "[0, 999]",
        JSON.stringify(filter),
      );

      const tickets = (response?.data ?? []) as unknown as Ticket[];

      return tickets;
    } catch (err: any) {
      return rejectWithValue(serializeError(err));
    }
  },
);
